import React from 'react';
export function WhySection() {
  return <>
      <section className="border-b border-navy/10 bg-white px-3 py-4 sm:px-6" data-id="element-159" data-mp="h18whbyucjx2">
        <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="13vt4m45kcu1o">
          <h2 className="text-center text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-161" data-mp="18ucqk4k5q5u1">
            Stop trying to understand cardiology from text alone
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-162" data-mp="1ik61r4ge0ixr">
            Not sure how an ECG pattern connects to what's happening in the heart? Different
            arrhythmias starting to look almost the same? ST changes, conduction blocks, cardiac
            imaging, valve abnormalities... what exactly should you be looking for? CARDIOLOGY VISUAL
            ATLAS™ gives you an organized visual study system to help you understand cardiac
            concepts, compare findings and recognize important cardiovascular patterns.
          </p>
          <p className="mt-1 text-center font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-163" data-mp="2666i6shlhgu">
            Interpret. Compare. Recognize.
          </p>
        </div>
      </section>

      <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-164" data-mp="28ptpgvb85hog">
        <div className="mx-auto max-w-2xl" data-id="element-165" data-mp="28qn1aap1ixdg">
          <h2 className="text-center text-[1.05rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.5rem]" data-id="element-166" data-mp="24o8ifqldfxm6">
            😩 Stop searching through different references for every cardiology topic
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-167" data-mp="2wewit0f80yys">
            You already study cardiology. The problem is wasting time jumping between textbooks,
            lecture slides, ECG websites and disconnected diagrams just to understand what you're
            actually seeing. Open the system, choose the cardiac topic and follow the organized
            visual references.
          </p>
          <p className="mt-1 text-center font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-168" data-mp="1byjf36l6vlhe">
            Less searching. More structured learning.
          </p>
        </div>
      </section>
    </>;
}